<template>
  <div class="conversations__conversation">
    <PhotoSwipe/>

    <div class="conversation__header">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="showChatsContainer()"
                 class="hidden-md-and-up"
                 dark
                 icon
                 v-on="on">
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('general.goBack') }}</span>
      </v-tooltip>

      <v-avatar class="mx-2"
                color="white"
                @click="seeUserDetails()"
                size="40px"
                style="cursor: pointer"
                v-if="roomName">
        <v-img :src="imageProfile"
               @error="onErrorImage()"
               v-if="imageProfile">
        </v-img>

        <v-icon v-else>
          mdi-account
        </v-icon>
      </v-avatar>

      <div class="conversation__title text-capitalize">
        <span @click="seeUserDetails()"
              style="cursor: pointer">
          {{ roomName }}
        </span>
      </div>

      <span v-if="showChangeAdviser">
        <v-menu bottom
                left
                max-height="300px"
                min-width="300px"
                v-model="showTransferToAgentMenu">
          <template #activator>
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn color="white"
                       id="changeAdviserMenuButton"
                       @click="getAdvisers()"
                       :loading="loadingAdvisers"
                       v-on="{...tooltip}"
                       icon>
                  <v-icon>
                    mdi-face-agent
                  </v-icon>
                </v-btn>
              </template>

              <span>{{$t('general.transferToAgent')}}</span>

            </v-tooltip>
          </template>

          <v-list dense>
            <v-text-field @click.stop
                          flat
                          hide-details
                          solo
                          label="Buscar asesor"
                          v-if="advisers.length > 0"
                          v-model="advisersFilter">
            </v-text-field>

            <v-divider></v-divider>

            <v-list-item @click="transferAdviser(adviser)"
                         v-for="adviser in connectedAdvisers"
                         :key="adviser._id">
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-avatar :color="getStatus(adviser).color"
                              size="10"
                              v-on="on">
                    </v-avatar>
                  </template>

                  <span>
                    {{getStatus(adviser).label}}
                  </span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  {{ adviser.name }}
                </v-list-item-title>

                <v-list-item-subtitle>
                  {{ adviser.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-subheader v-if="agents.length > 0">
              {{$t('general.agents')}}
            </v-subheader>

            <v-list-item @click="transferAdviser(agent)"
                         v-for="agent in agents"
                         :key="agent._id">
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon :color="getStatus(agent).color"
                            v-on="on">
                      mdi-robot
                    </v-icon>
                  </template>

                  <span>{{getStatus(agent).label}}</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  {{ agent.name }}
                </v-list-item-title>
              </v-list-item-content>
              </v-list-item>
          </v-list>
        </v-menu>
      </span>

      <v-btn @click="setAsEnded(null)"
             color="white"
             icon
             v-if="showEndsConversationButton && chatSettings.finishOptions.length === 0">
        <v-icon>
          feather-x-circle
        </v-icon>
      </v-btn>

      <span v-if="showEndsConversationButton && chatSettings.finishOptions.length > 0">
                <v-menu bottom
                        :close-on-content-click="false"
                        left
                        max-width="400px"
                        style="width: 400px"
                        v-model="menuFinishOptions">
                    <template v-slot:activator="{ on: menu }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn color="white"
                                       v-on="{ ...tooltip, ...menu }"
                                       icon>
                                    <v-icon>
                                        feather-x-circle
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('general.finishConversation') }}</span>
                        </v-tooltip>
                    </template>

                    <v-card>
                      <v-text-field clearable
                                    flat
                                    hide-details
                                    :placeholder="$t('general.findTerminationReason')"
                                    solo
                                    v-model="searchFinishOptions">
                      </v-text-field>

                      <v-divider/>

                      <v-card-text style="max-height: 300px; overflow-y: auto">
                        <v-row no-gutters>
                          <v-col cols="12"
                                 class="text-center"
                                 v-if="finishOptions.length === 0">
                            <v-icon color="error">
                              mdi-alert-circle
                            </v-icon>
                            {{$t('general.noAnswerFound')}}
                          </v-col>

                          <v-col cols="12"
                                 :key="option"
                                 v-for="option in finishOptions">
                            <CustomChip @click="setAsEnded(option)"
                                        :hide-actions="true">
                              {{ option }}
                            </CustomChip>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                </v-menu>
            </span>
    </div>

    <v-divider/>

    <TransferAgent v-model="showTransferAgentConfirmation" :adviser="adviserToTransfer"/>

    <div class="messages-container">
      <div class="messages-limiter"
           ref="chatContainer">
        <div style="flex: 1 1 auto"/>

        <Message :key="message._id"
                 :message="message"
                 v-for="message in messages">
        </Message>
      </div>

      <DropZone @clear="resetDropZone()"
                :enabled="selectedRoom"
                @filePicked="addFile($event)"
                :files="files"
                :imagesRefs="imagesRefs"
                @upload="uploadFile()"
                :uploadingFile="uploadingFile"
                :uploadProgress="uploadProgress"
                v-model="showDropZone">
      </DropZone>
    </div>

    <MessageComposer @attachFile="showDropZone = true"
                     v-if="selectedRoom">
    </MessageComposer>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapGetters, mapState } from 'vuex'
import conversationsService from '@/services/conversationsService.js'
import CustomChip from '@/pages/App/Conversations/components/CustomChip.vue'
import DropZone from '@/pages/App/Conversations/DropZone.vue'
import Message from '@/pages/App/Conversations/Message.vue'
import MessageComposer from '@/pages/App/Conversations/MessageComposer.vue'
import notifications from '@/libs/notifications'
import PhotoSwipe from '@/pages/App/Conversations/PhotoSwipe.vue'
import status from '@/libs/statusAgents'
import TransferAgent from '@/pages/App/Conversations/components/TransferAgent.vue'
export default {
  beforeDestroy () {
    this.$store.commit('SET_SELECTED_ROOM', '')
    this.$store.commit('SET_MESSAGES', [])
  },
  components: { CustomChip, DropZone, Message, MessageComposer, PhotoSwipe, TransferAgent },
  computed: {
    ...mapGetters(['chatSettings']),
    ...mapState({
      messages: state => state.conversations.messages,
      roomInfo: state => state.conversations.roomInfo,
      selectedRoom: state => state.conversations.selectedRoom,
      socket: state => state.conversations.socket,
      user: state => state.conversations.user,
      userKeybe: state => state.auth.userKeybe
    }),
    connectedAdvisers () {
      const filter = this.advisersFilter.toLowerCase()
      if (this.chatSettings.showConnectedAdvisorsOnly) {
        return this.advisers.filter(adviser => {
          return adviser.name.toLowerCase().includes(filter) && adviser.status === 'online'
        })
      }
      return this.advisers.filter(adviser => adviser.name.toLowerCase().includes(filter))
    },
    imageProfile () {
      if (this.errorImageProfile) return ''
      return this.user.image
    },
    roomName () {
      if (this.roomInfo.name) return this.roomInfo.name
      if (this.roomInfo.user && this.roomInfo.user.name) return this.roomInfo.user.name
      return ''
    },
    finishOptions () {
      if (!this.searchFinishOptions) return this.chatSettings.finishOptions
      const search = this.searchFinishOptions.toLowerCase()
      return this.chatSettings.finishOptions.filter(item => {
        return item.toLowerCase().includes(search)
      })
    },
    showEndsConversationButton () {
      return this.roomInfo && this.roomInfo.state !== 'ended' && this.roomInfo.advisorId === this.userKeybe.userId
    },
    showChangeAdviser () {
      if (!this.roomInfo) return false
      return this.roomInfo.advisorId === this.userKeybe.userId
    }
  },
  created () {
    this.connectToRoom()
    this.scrollBottom()
  },
  mounted () {
    this.audio = new Audio('https://storage.googleapis.com/keybe/app/audio/notification.mp3')
  },
  data: () => ({
    audio: null,
    advisers: [],
    advisersFilter: '',
    agents: [],
    adviserToTransfer: {},
    errorImageProfile: false,
    imagesRefs: [],
    files: [],
    loading: false,
    loadingAdvisers: false,
    menuFinishOptions: false,
    searchFinishOptions: '',
    showDropZone: false,
    showTransferToAgentMenu: false,
    showTransferAgentConfirmation: false,
    uploadingFile: false,
    uploadProgress: 0
  }),
  methods: {
    addFile (files) {
      for (let i = 0; i < files.length; i++) {
        this.files.push(files[i])
      }
    },
    checkExtension (file) {
      let extension = file.name.split('.')
      extension = extension.length > 1 ? `.${extension.pop()}` : ''
      extension = extension.toLocaleLowerCase()

      if (['.jpg', '.png', '.jpeg', '.pdf', '.ogg', '.mp4'].indexOf(extension) === -1) return false
      else return true
    },
    async checkFile (file) {
      let validFile = 'invalid'

      switch (file.type) {
        case 'image/jpeg':
          validFile = 'image'
          break
        case 'image/png':
          validFile = 'image'
          break
        case 'application/pdf':
          validFile = 'pdf'
          break
        case 'video/mp4':
          validFile = 'mp4'
          break
        default:
          validFile = 'invalid'
      }

      return validFile
    },
    connectToRoom () {
      if (!this.selectedRoom) return

      this.socket.emit('connectToRoom', { roomId: this.selectedRoom }, (err, data) => {
        if (err) return notifications.error(err.message)

        this.$store.commit('SET_MUST_SEND_TEMPLATES', data.mustSendTemplate)

        this.$store.commit('SET_MESSAGES', data.messages)
        this.scrollBottom()
      })
    },
    async getAdvisers () {
      try {
        this.loadingAdvisers = true
        const response = await this.$store.dispatch('getAdvisers')
        this.advisers = response.advisers
        this.agents = response.agents
        this.loadingAdvisers = false
        this.showTransferToAgentMenu = true
      } catch (e) {
        console.error(e)
      }
    },
    getStatus (adviser) {
      return status.find(status => {
        return status.value === adviser.status
      })
    },
    onErrorImage () {
      this.errorImageProfile = true
    },
    resetDropZone () {
      this.showDropZone = false
      this.files = []
      this.uploadingFile = false
      this.uploadProgress = 0
      this.imagesRefs = []
    },
    seeUserDetails () {
      this.$emit('changeCurrentComponent', 'DetailsContainer')
    },
    async sendMediaMessage (media, mimetype) {
      await this.$store.dispatch('sendMessage', { media, mimetype, text: '' })
    },
    async setAsEnded (reason) {
      try {
        this.menuFinishOptions = false
        const data = {
          action: 'end',
          reason: reason || this.$t('general.conversationFinishedByAdvisor'),
          roomId: this.selectedRoom
        }

        this.socket.emit('roomAction', data, (err, data) => {
            if (err) return console.log(err) // eslint-disable-line

          this.$store.commit('SET_SELECTED_ROOM', '')
          this.$store.commit('SET_ROOM_INFO', '')
          notifications.success(this.$t('general.finishedConversation'))
        })

        this.searchFinishOptions = ''
      } catch (e) {
        console.error(e)
      }
    },
    scrollBottom () {
      this.$nextTick(() => {
        if (this.$refs.chatContainer) {
          this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight
        }
      })
    },
    showChatsContainer () {
      this.$emit('changeCurrentComponent', 'ChatsContainer')
    },
    transferAdviser (adviser) {
      if (adviser.status === 'offline') {
        this.adviserToTransfer = adviser
        this.showTransferAgentConfirmation = true
      } else {
        this.loading = true

        const data = {
          action: 'transfer',
          advisorId: adviser.userId,
          roomId: this.selectedRoom
        }

        this.socket.emit('roomAction', data, err => {
          if (err) return notifications.error(err)
          this.loading = false

          this.socket.emit('leaveRoom', { roomId: this.selectedRoom })
          this.$store.commit('SET_MESSAGES', [])
          this.$store.commit('SET_SELECTED_ROOM', '')
          this.$store.commit('SET_ROOM_INFO', '')
        })
      }
    },
    updateProgress (progressEvent) {
      this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100 - 4)
    },
    async uploadFile () {
      const totalFiles = this.files
      if (totalFiles.length > 10) {
        notifications.error('No puedes enviar más de 10 archivos')
        this.resetDropZone()
        return
      }
      const fileTypes = []
      let fileType
      for (const file of totalFiles) {
        fileType = await this.checkFile(file)
        fileTypes.push(fileType)
        if (fileType === 'invalid') {
          notifications.error('Tipo de archivo inválido')
          this.resetDropZone()
          return
        }
        if (!this.checkExtension(file)) {
          notifications.error('Extensión de archivo inválida')
          return
        }
      }
      if (fileType === 'image') {
        if (fileTypes.some(f => f !== fileType)) {
          notifications.error('No puedes enviar varios tipos de archivos al tiempo')
          this.resetDropZone()
          return
        }
        this.uploadingFile = true
        this.uploadProgress = 0
        const response = await conversationsService.uploadImage(
          this.$store.getters.token,
          this.$store.getters.companyUuid,
          this.$store.getters.appUuid,
          this.selectedRoom,
          totalFiles,
          this.updateProgress
        )
        if (response.warning && response.warning.length > 0) {
          notifications.error(`Error al cargar las imagenes ${response.warning[0]}`)
          return
        }
        for (const url of response.urls) {
          await this.sendMediaMessage(url, response.mimetype)
        }
      } else if (fileType === 'pdf') {
        this.uploadingFile = true
        this.uploadProgress = 0
        const response = await conversationsService.uploadPdf(
          this.$store.getters.token,
          this.$store.getters.companyUuid,
          this.$store.getters.appUuid,
          this.selectedRoom,
          totalFiles[0],
          this.updateProgress
        )

        await this.sendMediaMessage(response.url, response.mimetype)
      } else if (fileType === 'mp4') {
        this.uploadingFile = true
        this.uploadProgress = 0
        const response = await conversationsService.uploadVideo(
          this.$store.getters.token,
          this.$store.getters.companyUuid,
          this.$store.getters.appUuid,
          this.selectedRoom,
          totalFiles[0],
          this.updateProgress
        )

        await this.sendMediaMessage(response.url, response.mimetype)
      }
      this.uploadingFile = false
      this.resetDropZone()
    }
  },
  watch: {
    messages () {
      this.scrollBottom()
    },
    imagesRefs () {
      if (this.imagesRefs.length > 10) {
        notifications.error('No puedes enviar mas de 10 imagenes')
        this.resetDropZone()
      }
    },
    selectedRoom (value) {
      if (!value) return this.$store.commit('SET_MESSAGES', [])

      this.files = []
      this.showDropZone = false
      this.uploadingFile = false
      this.uploadProgress = 0
      this.connectToRoom()
    },
    socket (value) {
      if (!value) return
      this.socket.on('chat', data => {
        if (data.roomId === this.selectedRoom) this.$store.commit('ADD_MESSAGES', data)
        if (data.sender === 'user') this.$store.commit('SET_MUST_SEND_TEMPLATES', false)
        EventBus.$emit('newMessage')
      })
      this.socket.on('waitingRoom', data => {
        if (data.message) {
          if (data.roomId === this.selectedRoom &&
            data.message.sender === 'listener' &&
            data.message.text === '') {
            this.$store.commit('SET_MESSAGES', [])
            this.$store.commit('SET_CONVERSATIONS_USER', '')
            this.$store.commit('SET_SELECTED_ROOM', '')
            this.$store.commit('SET_ROOM_INFO', '')
          } else if (data.roomId === this.selectedRoom &&
            data.message.sender === 'listener' &&
            data.message.text !== '') {
            this.audio.play()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import "../../../styles/Conversations/ConversationContainer.scss";
</style>
